import React, {Component} from 'react';
import './App.scss';
import {HashRouter as Router, Route} from "react-router-dom";
import Main from "../Main/Main";
import Login from "../Login/Login";
import {Redirect, Switch} from "react-router";
import createSagaMiddleware from 'redux-saga'
import {createStore, applyMiddleware, compose} from 'redux'
import reducers from '../../reducers'
import appSaga from '../../sagas/index'
import {Provider} from 'react-redux'
import {toast, ToastContainer} from "react-toastify";
import logger from 'redux-logger';
import {createIntl, createIntlCache, RawIntlProvider} from "react-intl";
import zh_CN from '../../locales/zh_CN';
import en_US from '../../locales/en_US';
import ja_JP from "../../locales/ja_JP";
import zh_HK from "../../locales/zh_HK";
import Forgot from "../Security/Forgot";
import Validation from "../Security/Validation";
import NoMatch from '../NoMatch';

// create the saga middleware
const sagaMiddleware = createSagaMiddleware()
// mount it on the Store
const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

let middleware = null
if (process.env.NODE_ENV === 'production') {
    middleware = applyMiddleware(sagaMiddleware)
} else {
    middleware = applyMiddleware(logger as any, sagaMiddleware)
}

export const store = createStore(
    reducers,
    composeEnhancers(middleware),
)

// then run the saga
sagaMiddleware.run(appSaga)

let messages: { [key: string]: any } = {};
messages["en"] = en_US;
messages["zh"] = zh_CN;
messages["zh-CN"] = zh_CN;
messages["zh-HK"] = zh_HK;
messages["zh-TW"] = zh_HK;
messages["ja"] = ja_JP;

let language = (navigator.languages && navigator.languages.length > 0) ? navigator.languages[0]
    : (navigator.language || 'en');
let short = language.substr(0, 2)
let message = messages[language] ? messages[language] : messages[short]

const cache = createIntlCache()


export const globalIntl = createIntl({
    locale: language,
    messages: message
}, cache)

class App extends Component {
    public render() {
        return (
            <Provider store={store}>
                <RawIntlProvider value={globalIntl}>
                    <Router>
                        <div className="App">
                            <Switch>
                                <Route path="/login" component={Login}/>
                                <Route path="/security/forgot" component={Forgot}/>
                                <Route path="/security/validation" component={Validation}/>
                                <Route path="/app" component={Main}/>
                                <Route path="/" exact>
                                    <Redirect to='/app/dashboard'/>
                                </Route>
                                <Route component={NoMatch} path="*"/>
                            </Switch>
                            <ToastContainer position={toast.POSITION.TOP_CENTER} autoClose={2000}
                                            hideProgressBar={true}/>
                        </div>
                    </Router>
                </RawIntlProvider>
            </Provider>

        );
    }
}

export default App;
